var map = {
	"./allbirds_logo--lg.png": [
		"./app/pages/MRX/MRXSolutions/UsedInOrgs/getLocalizedLogos/images/allbirds_logo--lg.png",
		0
	],
	"./ibm_logo--lg.png": [
		"./app/pages/MRX/MRXSolutions/UsedInOrgs/getLocalizedLogos/images/ibm_logo--lg.png",
		1
	],
	"./just_logo--lg.png": [
		"./app/pages/MRX/MRXSolutions/UsedInOrgs/getLocalizedLogos/images/just_logo--lg.png",
		2
	],
	"./rj_logo--lg.png": [
		"./app/pages/MRX/MRXSolutions/UsedInOrgs/getLocalizedLogos/images/rj_logo--lg.png",
		3
	],
	"./tweezerman_logo--lg.png": [
		"./app/pages/MRX/MRXSolutions/UsedInOrgs/getLocalizedLogos/images/tweezerman_logo--lg.png",
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./app/pages/MRX/MRXSolutions/UsedInOrgs/getLocalizedLogos/images lazy recursive ^\\.\\/.*\\-\\-lg\\.png$";
module.exports = webpackAsyncContext;